import * as React from 'react';
import { Typography, Accordion, AccordionSummary, AccordionDetails, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Link } from '@mui/icons-material';

const Heading = styled(Typography, {
    shouldForwardProp: (prop) => prop !== 'failed',
})<{ failed?: boolean }>(({ theme, failed }) => ({
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
    ...(failed && { color: theme.palette.error.main }),
}));

const LinkButton = styled(IconButton)({
    position: 'absolute',
    marginTop: '-11px',
    marginLeft: '5px',
});

const isLinkReg = /https?:\/\//;
const isLink = (txt: string) => {
    return isLinkReg.test(txt);
}

export interface Props {
    report: {
        label?: string,
        key: string,
        groups: Array<{
            key: string,
            results: Array<{
                key: string;
                label: string | null;
                value: any;
                qualitative: 'good' | 'average' | 'bad' | null,
                valueType: string,
                fail: boolean,
                threshold?: any,
                ignore?: boolean
            }>
        }>
    }
}

const wordBreakAllStyle: any = { wordBreak: "break-all" };

const Result = (props: {
    label: string,
    value: any,
    threshold?: any,
    fail: boolean,
    ignore?: boolean
}) => {

    return (
        <div style={{ marginBottom: 16, opacity: props.ignore === true ? 0.3 : 1 }}>
            <Typography variant="caption" style={wordBreakAllStyle} sx={{ color: props.fail ? 'error.main' : 'text.secondary' }}>{props.label}</Typography>
            <Typography variant="body1" component="p">
                <Typography component="span" style={wordBreakAllStyle} sx={{ display: 'inline', color: props.value != null ? 'text.primary' : 'text.secondary' }}>{props.value.toString()}</Typography>
                {props.threshold != null && <Typography style={wordBreakAllStyle} component="span" sx={{ display: 'inline', color: 'text.secondary' }}> ({props.threshold.toString()})</Typography>}
            </Typography>
        </div>
    )
}

export class SimpleReport extends React.PureComponent<Props>{

    handleLinkClick = (e: any) => {
        e.stopPropagation();
        window.open(e.target.dataset.url, '_blank');
    }

    render() {
        const { report } = this.props;
        const reportKeySplitted = report.key.replace(/:/, '__:__').split('__:__');

        return (
            <React.Fragment>
                <Typography component="div" variant="h6">{`${report.label != null ? `[${report.label}] ` : ''} ${reportKeySplitted[0]}`}</Typography>
                <Typography component="div" variant="caption" style={{ wordWrap: 'break-word' }}>{reportKeySplitted[1]}</Typography>
                <br />
                {report.groups.map(group => {
                    const groupContainsError = group.results.findIndex(x => x.fail && x.ignore !== true) !== -1;
                    return (
                        <Accordion>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                <Heading failed={groupContainsError}>{group.key}</Heading>
                                {isLink(group.key) && <div><LinkButton
                                    data-url={group.key}
                                    onClick={this.handleLinkClick}
                                    size="large"><Link sx={{
                                        fontSize: "small"
                                    }} /></LinkButton></div>}
                            </AccordionSummary>
                            <AccordionDetails style={{ minWidth: '200px', maxWidth: '80vw', display: 'block' }}>
                                {group.results.map(result => (
                                    <Result label={result.key} value={result.value} fail={result.fail} ignore={result.ignore} threshold={result.threshold} />
                                ))}
                            </AccordionDetails>
                        </Accordion>
                    );
                })}
            </React.Fragment>
        );
    }
}
